<template>
    <m-filter text="Product" :popup.sync="popup" :filtered="filtered">
        <m-lookup :data="products" @select="select"></m-lookup>
    </m-filter>
</template>

<script>
export default {
    props: {
        value: Object
    },
    data: () => ({
        products: window.initial.products,
        popup: false
    }),
    methods: {
        select(s) {
            this.$emit('input', s)
            this.popup = false
        }
    },
    computed: {
        filtered() {
            if (!this.value) {
                return ''
            }
            return this.value.value
        }
    }
}
</script>

